import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { TPVServices } from "../../services";
import { ReservationLoaderPage } from "../../../reservation/reservation-loader/reservation-loader";
import { HomePage } from '../../../home/home';
import { BlockScreenPage } from '../../../components/block-screen/block-screen';
import { OrdersCoServices } from '../../../orders/services';
import { Globals } from '../../../../globals';
import { TranslateService } from '@ngx-translate/core';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { PopupNewAppsPage } from '../../../components/popups/popup-new-apps/popup-new-apps';

/**
 * Generated class for the TpvRoomMenuPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-tpv-select-menu',
  templateUrl: 'tpv-select-menu.html',
})
export class TpvRoomMenuPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public tpvServices: TPVServices,
    public ordersCoServices: OrdersCoServices,
    public globals: Globals,
    public translate: TranslateService,
    public toastCtrl: ToastController) {

  }

  /**********************************************************/
  /*                        FUNCIONES                       */
  /**********************************************************/

  //open takeaway orders
  takeAway() {
    if (this.globals.checkLimitsByLicense('tpv', 'takeaway')) {
      if (this.globals.connection) {
        this.tpvServices.menu_select_room = 'take_away';
        this.globals.GAtrackView('TakeAway', 'TakeAway - List', this.globals.restaurant.email, 'View', 'List takeaway', 'TakeAway', '');
      } else {
        this.globals.launchToastNoConnection();
      }
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  //open room to show tables
  openRoom(room, index) {
    if (this.globals.checkLimitsByLicense('config', 'rooms') == -1) { //NO LIMIT
      this.tpvServices.room_selected_uid = room.UID;
      this.tpvServices.room_selected_name = room.name;
      this.tpvServices.menu_select_room = 'room';
      this.tpvServices.room_selected_map = room.map;
      this.globals.GAtrackView('TPV', 'TPV - Rooms - List', this.globals.restaurant.email, 'View', 'List rooms TPV', 'TPV', '');
      this.globals.tourLaunchStep(2);
    } else {
      if (index < this.globals.checkLimitsByLicense('config', 'rooms')) {
        this.tpvServices.room_selected_uid = room.UID;
        this.tpvServices.room_selected_name = room.name;
        this.tpvServices.menu_select_room = 'room';
        this.tpvServices.room_selected_map = room.map;
        this.globals.GAtrackView('TPV', 'TPV - Rooms - List', this.globals.restaurant.email, 'View', 'List rooms TPV', 'TPV', '');
        this.globals.tourLaunchStep(2);
      } else {
        this.navCtrl.push(AddonsTriggerVersionProPage);
      }
    }
  }

  /**********************************************************/
  /*                         NAVCTRL                        */
  /**********************************************************/

  //open calendar
  openCalendar() {
    if (this.globals.checkLimitsByLicense('reservations', 'calendar')) {
      this.globals.side_menu_active = 'reservation';
      this.navCtrl.push(ReservationLoaderPage);
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  //open comandero
  openOrders() {
    if (this.globals.checkLimitsByLicense('tpv', 'comandero')) {
      this.globals.side_menu_active = 'order';
      this.navCtrl.push(PopupNewAppsPage, { app: 'order' });
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  //close
  close() {
    this.globals.side_menu_active = 'dashboard';
    this.navCtrl.setRoot(HomePage);
  }

  //open blockscreen
  block() {
    if (this.globals.checkLimitsByLicense('screen_block', 'block')) {
      if (this.globals.connection) {
        this.navCtrl.push(BlockScreenPage, {
          type: 'tpv',
        });
      } else {
        this.globals.launchToastNoConnection();
      }
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/tpv/tpv-select/tpv-select-menu/tpv-select-menu.ts